import React, { useEffect, useState } from "react";
import { database } from "../firebase";
import { useDispatch, useSelector } from "react-redux";
import Loader from "./Loader";
import moment from "moment";
import { DotLoader } from "react-spinners";
import { css } from "@emotion/react";

function PendingCreditz(dummystate) {
  const { currentUser } = useSelector((state) => ({
    currentUser: state.profile.currentUser,
  }));

  const [pending, setPending] = useState([]);
  const [loading, setLoading] = useState(false);

  function getUserData(uid) {
    return new Promise((resolve, reject) => {
      return database.ref("users/" + uid).once("value", (snap) => {
        resolve(snap.val());
      });
    });
  }

  function getCreditzData(credid) {
    return new Promise((resolve, reject) => {
      return database.ref("creditz/" + credid).once("value", (snap) => {
        resolve(snap.val());
      });
    });
  }

  function getUserCreditzData(credid) {
    return new Promise((resolve, reject) => {
      return database.ref("user-creditz/" + credid).once("value", (snap) => {
        resolve(snap.val());
      });
    });
  }
  function pendingCreditz() {
    return database
      .ref(`/user-creditz/`)
      .once("value")
      .then(async (snapshot) => {

        const creditRequests = [];
        const request = [];
        let us = [];

        snapshot.forEach((childSnapshot) => {
          request.push(Object.values(childSnapshot.val()))
          us = request.map(req => {
            return req.find(r => {
              return r.email === currentUser.email;
            })
          }).filter((e) => e);;

        });


        const pendingRequests = [];

        us.map((req) => {

            if (req.status === "Pending ") {
              pendingRequests.push(req);
            }
          })
          .filter((e) => e);

        var newRes = await Promise.all(
          pendingRequests.map(async (user) => {
            const Data = await getUserData(user.uid);
            const Creddata = await getCreditzData(user.credid);
            const returnObj = {
              credid: user.credid,
              role:user.role,
              user_details: Data,
              Creditz: Creddata,
            };

            return returnObj;
          })
        );
        setPending(newRes);
      });
  }

  async function acceptConnection(credid, userId) {
    setLoading(true);
    notifications();
    const Creddata = await getUserCreditzData(credid);
    const credObj = []


    const k = Object.keys(Creddata).filter(key => {
      return Creddata[key].email === currentUser.email
    })

    const user_id = k.length > 0 ? k[0] : null;

    const updates = {};
    updates[`user-creditz/${credid}/${user_id}/status`] = "Accepted ";
   
    await database
      .ref()
      .update(updates)
      .then(() => {
        return database
          .ref(`/user-creditz/`)
          .once("value")
          .then(async (snapshot) => {

            const creditRequests = [];
            const request = [];
            let us = [];
            // const res = [];
            // const response = [];

            snapshot.forEach((childSnapshot) => {

              request.push(Object.values(childSnapshot.val()))
              // if (Object.keys(childSnapshot.val()).includes(currentUser.uid)) {
              //   creditRequests.push(childSnapshot.val());
              // }
              us = request.map(req => {
                return req.find(r => {
                  return r.email === currentUser.email;
                })
              }).filter((e) => e);;

            });
            const pendingRequests = [];


            us
              .map((req) => {



                if (req.status === "Pending ") {
                  pendingRequests.push(req);
                }
              }).filter((e) => e);

            var newRes = await Promise.all(
              pendingRequests.map(async (user) => {
                const Data = await getUserData(user.uid);
                const Creddata = await getCreditzData(user.credid);
                const returnObj = {
                  credid: user.credid,
                  user_details: Data,
                  Creditz: Creddata,
                };

                return returnObj;
              })
            );
            setPending(newRes);

          })
          .then(() => {
            return database
              .ref(`/user-creditz/`)
              .once("value")
              .then(async (snapshot) => {

                const creditRequests = [];
                const request = [];
                let us = [];
                // const res = [];
                // const response = [];

                snapshot.forEach((childSnapshot) => {

                  request.push(Object.values(childSnapshot.val()))
                  // if (Object.keys(childSnapshot.val()).includes(currentUser.uid)) {
                  //   creditRequests.push(childSnapshot.val());
                  // }
                  us = request.map(req => {
                    return req.find(r => {
                      return r.email === currentUser.email;
                    })
                  }).filter((e) => e);;

                });


                const pendingRequests = [];


                us
                  .map((req) => {


                    // const obj = Object.values(req);
                    if (req.status === "Accepted ") {
                      pendingRequests.push(req);
                    }
                  })
                  .filter((e) => e);

                var newRes = await Promise.all(
                  pendingRequests.map(async (user) => {
                    const Data = await getUserData(user.uid);
                    const Creddata = await getCreditzData(user.credid);
                    const returnObj = {
                      credid: user.credid,
                      role:user.role,
                      user_details: Data,
                      Creditz: Creddata,
                    };

                    return returnObj;
                  })
                );
                setAccepted(newRes);
                setLoading(false);
              });
          });
      });

    return true;
    // database.ref(`/connectuser/SsxSEzQiq3ajtFgfDiUMarwVdC63/${uid}`).update({ status: "Accepted" });
  }
  async function DeclineConnection(credid, userId) {
    setLoading(true);
    notifications();
    const Creddata = await getUserCreditzData(credid);
    const credObj = []


    const k = Object.keys(Creddata).filter(key => {
      return Creddata[key].email === currentUser.email
    })

    const user_id = k.length > 0 ? k[0] : null;

    const updates = {};
    //  const updates2={};
    updates[`user-creditz/${credid}/${user_id}/status`] = "Rejected ";
    //   updates2[`Notifications/${currentUser.uid}/${credid}/status`] = "Accepted";
    // await database.ref().update(updates2)
    await database
      .ref()
      .update(updates)
      .then(() => {
        return database
          .ref(`/user-creditz/`)
          .once("value")
          .then(async (snapshot) => {

            const creditRequests = [];
            const request = [];
            let us = [];
            snapshot.forEach((childSnapshot) => {
          
              request.push(Object.values(childSnapshot.val()))
       
              us = request.map(req => {
                return req.find(r => {
                  return r.email === currentUser.email;
                })
              }).filter((e) => e);;

            });
            const pendingRequests = [];


            us
              .map((req) => {
        
                if (req.status === "Pending ") {
                  pendingRequests.push(req);
                }
              })
              .filter((e) => e);

            var newRes = await Promise.all(
              pendingRequests.map(async (user) => {
                const Data = await getUserData(user.uid);
                const Creddata = await getCreditzData(user.credid);
                const returnObj = {
                  credid: user.credid,
                  user_details: Data,
                  Creditz: Creddata,
                };

                return returnObj;
              })
            );
            setPending(newRes);

          })
          .then(() => {
            return database
              .ref(`/user-creditz/`)
              .once("value")
              .then(async (snapshot) => {

                const creditRequests = [];
                const request = [];
                let us = [];
                // const res = [];
                // const response = [];

                snapshot.forEach((childSnapshot) => {
                
                  request.push(Object.values(childSnapshot.val()))
                  us = request.map(req => {
                    return req.find(r => {
                      return r.email === currentUser.email;
                    })
                  }).filter((e) => e);;

                });

                const pendingRequests = [];


                us
                  .map((req) => {

                
                    if (req.status === "Accepted ") {
                     
                      pendingRequests.push(req);
                    }
                  })
                  .filter((e) => e);

                var newRes = await Promise.all(
                  pendingRequests.map(async (user) => {
                    const Data = await getUserData(user.uid);
                    const Creddata = await getCreditzData(user.credid);
                    const returnObj = {
                      credid: user.credid,
                      user_details: Data,
                      Creditz: Creddata,
                    };

                    return returnObj;
                  })
                );
                setAccepted(newRes);
                setLoading(false);
              });
          });
      });

    return true;
  }
  const [accepted, setAccepted] = useState([]);
  function getUserData(uid) {
    return new Promise((resolve, reject) => {
      return database.ref("users/" + uid).once("value", (snap) => {
        resolve(snap.val());
      });
    });
  }

  function getCreditzData(credid) {
    return new Promise((resolve, reject) => {
      return database.ref("creditz/" + credid).once("value", (snap) => {
        resolve(snap.val());
      });
    });
  }
  function AcceptedCreditz(dummystate) {
    setLoading(true);
    return database
      .ref(`/user-creditz/`)
      .once("value")
      .then(async (snapshot) => {

        const creditRequests = [];
        const request = [];
        let us = [];
      

        snapshot.forEach((childSnapshot) => {
 
          request.push(Object.values(childSnapshot.val()))
      
          us = request.map(req => {
            return req.find(r => {
              return r.email === currentUser.email;
            })
          }).filter((e) => e);

        })


        const pendingRequests = [];


        us.map((req) => {
         
            if (req.status === "Accepted ") {
              pendingRequests.push(req);
            }
          }).filter((e) => e);

        var newRes = await Promise.all(
          pendingRequests.map(async (user) => {
            const Data = await getUserData(user.uid);
            const Creddata = await getCreditzData(user.credid);
            const returnObj = {
              credid: user.credid,
              role:user.role,
              user_details: Data,
              Creditz: Creddata,
            };

            return returnObj;
          })
        );
        setAccepted(newRes);
        setLoading(false);
      });
  }

  function notifications() {
    pending.map((email) => {
      return database
        .ref("Notifications/")
        .child(email.Creditz.uid)
        .push({
          sender: currentUser.uid,
          status: "Accepted",
          credid: email.credid,
          type: 'Creditz',
          timestamp: moment().toDate().getTime(),
          isDeleted: 'false',
          isread: "false"
        });
    });

  }

  
  const override = css`
  display: block;
  margin: 0 auto;
  border-color: purple;
  color: purple;
  opacity: 0.5;
  `;

  let [color] = useState();
console.log('pending',pending)
  useEffect(() => {
    pendingCreditz();
    AcceptedCreditz();
  }, []);
  return loading == true ? (
    <DotLoader color={color} css={override} size={75} color={"#7444C0"}
    />
  ) : (
    <>
      <div className="table-responsive">
        <table className="table align-middle text-center">
          <colgroup>
            <col width="140" />
            <col width="80" />
            <col />
            <col />
            <col />
            <col width="170" />
          </colgroup>
          <thead className="bg-lightblue-gradient text-primary fw-semibold">
            <tr>
              <td className="border-bottom">Sender</td>
              <td className="border-bottom">Artwork</td>
              <td className="border-bottom">Type</td>
              <td className="border-bottom">Title</td>
              <td className="border-bottom">Role</td>
              <td className="border-bottom">Reaction</td>
            </tr>
          </thead>
          <tbody>
            {pending &&
              pending.map((pendrequest, ind) => (
                <tr key={ind}>
                  <td>{pendrequest?.Creditz?.username}</td>
                  <td>
                    <img
                      src={pendrequest?.Creditz?.albumImage} />
                  </td>
                  <td>{pendrequest?.Creditz?.category}</td>
                  <td>
                    {pendrequest?.Creditz?.category==='Youtube Video'?pendrequest?.Creditz?.youtubetitle:pendrequest.Creditz?.trackname}
           
                    </td>
                  <td>
                    <span className="badge pendrequestpx-3 py-2 rounded-pill fw-medium bg-blue">
                      {pendrequest?.role}
                    </span>
                  </td>
                  <td>
                    <button
                      onClick={() => acceptConnection(pendrequest.credid)}
                      type="button"
                      className="btn btn-sm btn-primary rounded-pill m-1"
                    >
                      Accept
                    </button>
                    <button
                      onClick={() => DeclineConnection(pendrequest.credid)}
                      className="btn btn-sm btn-secondary rounded-pill m-1"
                    >
                      Ignore
                    </button>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
        <h5 className="fw-semibold my-3">Accepted Creditz</h5>
        <table className="table align-middle text-center">
          <colgroup>
            <col width="140" />
            <col width="80" />
            <col />
            <col />
            <col />
            <col width="170" />
          </colgroup>
          <thead className="bg-lightblue-gradient text-primary fw-semibold">
            <tr>
              <td className="border-bottom">Sender</td>
              <td className="border-bottom">Artwork</td>
              <td className="border-bottom">Type</td>
              <td className="border-bottom">Title</td>
              <td className="border-bottom">Role</td>
            </tr>
          </thead>
          <tbody>
            {accepted &&
              accepted.map((pendrequest) => (
                <tr>
                  <td>{pendrequest?.Creditz.username}</td>
                  <td>
                    <img
                      src={pendrequest?.Creditz.albumImage} />
                  </td>
                  <td>{pendrequest?.Creditz.category}</td>
                  <td> {pendrequest?.Creditz.category==='Youtube Video'?pendrequest.Creditz.youtubetitle:pendrequest.Creditz.trackname}</td>
                  <td>
                    <span className="badge px-3 py-2 rounded-pill fw-medium bg-blue">
                      {pendrequest?.role}
                    </span>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </>
  );
}
export default PendingCreditz;
